import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import UserTooling from '../../../tooling/userTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import Constants from '../../../definitions/constants';

import TextBox from '../common/inputs/textBox';
import CheckBox from '../common/inputs/checkBox';

const ReprocessForm = props => {
  const {
    handleOnChangeForm,
    formData,
    hideFixPolynomials
  } = props;
  return (
    <div className="reprocess_form">
      <TextBox 
        styleType={Constants.interface.inputs.styleType.OUTLINED}
        type={Constants.interface.inputs.type.TEXT}
        id="default_reprocess_tag"
        data-path="default_reprocess_tag"
        value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"default_reprocess_tag")}
        onChange={handleOnChangeForm}
        labelLocale={<FormattedMessage id="periodAdmin.reprocessFormFields.default_reprocess_tag"/>}
      />
      <TextBox 
        styleType={Constants.interface.inputs.styleType.OUTLINED}
        type={Constants.interface.inputs.type.TEXT}
        id="default_reprocess_file_string"
        data-path="default_reprocess_file_string"
        value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"default_reprocess_file_string")}
        onChange={handleOnChangeForm}
        labelLocale={<FormattedMessage id="periodAdmin.reprocessFormFields.default_reprocess_file_string"/>}
        className={"default_reprocess_file_string_label"}
      />
      {(!hideFixPolynomials) && (
        <div className="fix_polynomials_section">
          <div className="row_fields">
            <CheckBox 
              id="fix_polynomials"
              data-path="fix_polynomials"
              value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"fix_polynomials")}
              onChange={handleOnChangeForm}
              labelLocale={<FormattedMessage id="periodAdmin.reprocessFormFields.fix_polynomials"/>}
              className="fix_polynomials_checkbox"
            />
            {JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"fix_polynomials") && (
              <TextBox 
                styleType={Constants.interface.inputs.styleType.OUTLINED}
                id="fix_polynomials_date"
                data-path="fix_polynomials_date"
                value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"fix_polynomials_date")}
                onChange={handleOnChangeForm}
                labelLocale={<FormattedMessage id="periodAdmin.reprocessFormFields.fix_polynomials_date"/>}
                dataType={Constants.textFiltersDataTypes.DATETIME}
              />
            )}
          </div>
          {JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"fix_polynomials") && (
            <label className="form_info">
              <FormattedMessage 
                id={"periodAdmin.reprocessEmptyDateInfo"}
              />
            </label>
          )}
        </div>
      )}
    </div>
  );
};

export default ReprocessForm;



// WEBPACK FOOTER //
// ./source/client/components/periodAdmin/reprocessForm.jsx